export const messages = {
  rollbackRfq: {
    success: 'Rfq successfully rolled back',
    error: 'Rollback rfq error',
  },
  rawData: {
    error: 'Error downloading raw data',
  },
}
